// Shared helpers used across the Admin dashboard tab panels and detail dialogs.
// Keeping them in one tiny module stops each tab from redeclaring the same
// badge map / testid wrapper, and makes future styling tweaks a single edit.

export const STEP_STYLES = {
  "Active": "bg-sage-light text-sage-dark",
  "Payment Pending": "bg-amber-100 text-amber-800",
  "Pending Approval": "bg-amber-100 text-amber-800",
  "Approval Rejected": "bg-terracotta-light text-terracotta-dark",
  "Profile Setup": "bg-softstone/80 text-forest/70",
  "Email Not Verified": "bg-softstone/80 text-forest/70",
  "Unknown": "bg-softstone/80 text-forest/70",
};

export function StepBadge({ step, testid }) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wide ${STEP_STYLES[step] || STEP_STYLES.Unknown}`}
      data-testid={testid}
    >
      {step}
    </span>
  );
}

// Build a public URL for a backend-stored file path. Returns "" for falsy
// inputs so callers can safely use it inside `src={fileHref(x)}` without
// extra guards.
export const fileHref = (p) => (p ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${p}` : "");

// Compact 2-column label/value row used in every detail dialog. Renders "—"
// for empty-ish values so blank slots stay visually obvious.
export function DetailRow({ label, value, testid }) {
  const display = value === null || value === undefined || value === "" ? "—" : String(value);
  return (
    <div className="grid grid-cols-[130px_1fr] gap-3 py-1.5 border-b border-sage/10 last:border-b-0" data-testid={testid}>
      <span className="text-xs font-bold uppercase tracking-wide text-forest/50">{label}</span>
      <span className="text-sm text-forest break-words">{display}</span>
    </div>
  );
}
